import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Particles } from '@onereach/particles';
import { useDebounceFn, useEventListener } from '@vueuse/core';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import OnereachLogo from '../../assets/login-logo-next.png';
const animationDelay = 3500;
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrAnimationLogo',
    setup(__props) {
        let animation = null;
        const animationWrapper = ref();
        const isHovered = ref(false);
        const pauseOnHover = () => {
            isHovered.value = false;
            pauseIfNotHovered();
        };
        const activateOnHover = () => {
            isHovered.value = true;
            if (!(animation === null || animation === void 0 ? void 0 : animation.renderProcessId)) {
                animation === null || animation === void 0 ? void 0 : animation.render();
            }
        };
        const pauseIfNotHovered = useDebounceFn(() => {
            if (!isHovered.value) {
                animation === null || animation === void 0 ? void 0 : animation.pauseAnimation();
            }
        }, animationDelay);
        onMounted(async () => {
            var _a;
            animation = new Particles({
                container: animationWrapper.value,
                imagePath: OnereachLogo,
                options: {
                    particleSize: 2,
                    particlesAmount: 120000,
                },
            });
            await animation.init();
            isHovered.value = ((_a = animationWrapper.value) === null || _a === void 0 ? void 0 : _a.matches(':hover')) || false;
            if (!document.hidden) {
                animate();
            }
            else {
                useEventListener(window, 'focus', animate, { once: true });
            }
            useEventListener(animationWrapper, 'mouseenter', activateOnHover);
            useEventListener(animationWrapper, 'mouseleave', pauseOnHover);
        });
        const animate = () => {
            animation === null || animation === void 0 ? void 0 : animation.reveal();
            pauseIfNotHovered();
        };
        onBeforeUnmount(() => {
            animation === null || animation === void 0 ? void 0 : animation.destroy();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "animationWrapper",
                ref: animationWrapper,
                class: "block h-[650px] w-[650px] overflow-visible min-w-[650px]"
            }, null, 512));
        };
    }
});
